import React from 'react'
import { PlatformDescription } from './style'
import CustomLogo from '../Logo'

const MessageLogin = () => {
    return (
        <>
            <div className="text-center">
                <CustomLogo logoType="login" />
            </div>
            <PlatformDescription>
                La nueva plataforma de {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href="https://www.placetopay.com/web/" target="_blank" rel="noopener noreferrer">
                    Place to Pay{' '}
                </a>{' '}
                que te ayudará a agilitar tus procesos de pago evitando congestión en tu
                establecimiento.
            </PlatformDescription>
        </>
    )
}

export default MessageLogin
